/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-18 17:39:05
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-10-19 08:15:28
 */
import { login, logout, getInfo, phonelogin } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { fetchDetail } from '@/api/my'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  admin_id: "",
  isupd: 0,
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ADMIN_ID: (state, admin_id) => {
    state.admin_id = admin_id
  },
  SET_UPD_PWD: (state, isupd) => {
    state.isupd = isupd
  }
}

const actions = {
  // 
  phonelogin ({ commit }, userInfo) {
    const { username, password, phone, phonecode } = userInfo
    return new Promise((resolve, reject) => {
      //   login({ username: username.trim(), password: password }).then(response => {
      //     const { data } = response
      //     commit('SET_TOKEN', data.token)
      //     setToken(data.token)
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
      phonelogin({ username: username, password: password, phone: phone.trim(), phonecode: phonecode }).then(response => {
        if (response.code != 200) {
          resolve()
          return
        }
        const data = response.result;
        commit('SET_TOKEN', data.token)
        commit('SET_ADMIN_ID', data.id)
        commit('SET_UPD_PWD', data.is_upd)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  login ({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      //   login({ username: username.trim(), password: password }).then(response => {
      //     const { data } = response
      //     commit('SET_TOKEN', data.token)
      //     setToken(data.token)
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
      login({ name: username.trim(), password: password }).then(response => {
        if (response.code != 200) {
          resolve()
          return
        }
        const data = response.result;
        commit('SET_TOKEN', data.token)
        commit('SET_ADMIN_ID', data.id)
        commit('SET_UPD_PWD', data.is_upd)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.token) {
        return
      }
      getInfo(state.token).then(response => {
        if (response.code != 200 || !response.result) {
          reject(response.message || 'Verification failed, please Login again.')
          return
        }
        const data = response.result

        const { name, avatar } = data

        commit('SET_ROLES', [])
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', '')
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      //直接清掉，不走接口
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      dispatch('permission/clearRoutes', null, { root: true })
      dispatch('tagsView/delAllViews', null, { root: true })
      resolve()

      // 以下是走接口的写法
      //   logout(state.token).then(async() => {
      //     commit('SET_TOKEN', '')
      //     commit('SET_ROLES', [])
      //     removeToken()
      //     resetRouter()
      //     await dispatch('permission/clearRoutes', null, { root: true })
      //     await dispatch('tagsView/delAllViews', null, { root: true })
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // 个人信息
  getUserInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      fetchDetail().then(response => {
        const { username, avatar } = response.data.detail
        commit('SET_NAME', username)
        commit('SET_AVATAR', avatar)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
